<script>
    /* v-model container for form post element  */

    export default {
        data() {
            return Object.assign({
                manage_role_modal : false,
            }, __FORM__, {locale: window.locale});
        },
        computed: {
        },
        watch : {
        },
        mounted() {
        },
        methods : {
            submit() {
                let formData = this.getFormData();

                this.$validator.validateAll()
                    .then((result) => {
                        if(result) {
                            let formData = this.getFormData();
                            let ajaxSuccessCallback = (response) => {
                                this.$nextTick(function () {
                                    window.location.href = this.redirect_url;
                                    this.$store.commit('setRedirectNotification', response.data.msg);
                                    this.$store.commit('setNotificationType', 'success');
                                });
                            };
                            let ajaxFailCallback = (error) => {
                                if (error.response.status == '422') {
                                    this.$store.commit('setValidationError', error.response.data.errors)
                                } else {
                                    this.$store.commit('setError', error.response.data.msg)
                                }
                            };
                            this.$root.ajax_call(this.url, this.method, formData, ajaxSuccessCallback, ajaxFailCallback, true);

                        } else {
                            this.$store.commit('setVeeValidationError', this.errors);
                        }
                    });

            },
            getFormData() {
                let formData = {};
                formData = {
                    en_display_name : this.en_display_name,
                    other_display_name : this.other_display_name,
                    en_description : this.en_description,
                    other_description : this.other_description,
                    users : this.selected_users,
                };

                return formData;
            },
            cancelUserPicker() {
                this.manage_role_modal = false;
                window.eventHub.$emit('update-picker-selected-users', this.selected_users);
            },
            openRoleUserPicker(selected_user)
            {
                this.manage_role_modal = true;
            },
            submitRoleInfo() {
                this.selected_users = this.$root.retrieveUserPickerSelectedUsers();
                this.manage_role_modal = false;
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modules/system-management/administrator/RoleForm.vue